const SKIP_FIELDS = new Set(['_splits', 'split'])

export function compactKey(value: string): string {
  return (value || '').replace(/[\s/._-]+/g, '').toLowerCase()
}

export function sameSurface(left: string, right: string): boolean {
  const strip = (value: string) => (value || '').trim().replace(/^[*∗✱⁎＊✳.,]+|[*∗✱⁎＊✳.,]+$/g, '').trim()
  const a = strip(left)
  const b = strip(right)
  if (!a || !b) return false
  if (a.toLowerCase() === b.toLowerCase()) return true
  const compact = (value: string) => value.replace(/[\s/._-]+/g, '').toLowerCase()
  const key = compact(a)
  return Boolean(key) && key === compact(b)
}

export function compactTokenKey(value: string): string {
  return (value || '').replace(/[\s/._*∗✱⁎＊✳–—‑−-]+/g, '').toLowerCase()
}

export function knownTokenStatus<T extends { field?: string }>(
  token: string,
  known: Record<string, T> | null | undefined,
): T | undefined {
  if (!token || !known) return undefined
  const key = compactTokenKey(token)
  if (key) {
    for (const [stored, status] of Object.entries(known)) {
      if (status?.field !== 'ignore') continue
      if (compactTokenKey(stored) === key) return status
    }
  }
  return known[token] || known[token.toLowerCase()]
}

function entryToken(entry: unknown): string {
  if (typeof entry === 'string') return entry.trim()
  if (entry && typeof entry === 'object' && 'token' in entry) {
    const token = (entry as { token?: unknown }).token
    return typeof token === 'string' ? token.trim() : ''
  }
  return ''
}

export function countTokenPatterns(
  tokenPatterns: Record<string, unknown> | null | undefined,
): number {
  const seen = new Set<string>()
  if (!tokenPatterns || typeof tokenPatterns !== 'object') return 0
  const splits =
    tokenPatterns._splits &&
    typeof tokenPatterns._splits === 'object' &&
    !Array.isArray(tokenPatterns._splits)
      ? (tokenPatterns._splits as Record<string, unknown>)
      : {}
  for (const [field, tokens] of Object.entries(tokenPatterns)) {
    if (SKIP_FIELDS.has(field) || !Array.isArray(tokens)) continue
    for (const entry of tokens) {
      const key = entryToken(entry).toLowerCase()
      if (!key || key in splits) continue
      seen.add(key)
    }
  }
  return seen.size
}
